import * as React from "react";
import { Plane, TrainFront, CloudRain, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const essentialsData = [{
  id: "network",
  title: "Netzwerksicherheit",
  description: "Hochverfügbare Schutzwälle für Ihre Datenströme und interne Kommunikation.",
  icon: ShieldCheck,
  badge: "Status: Aktiv",
  badgeVariant: "default" as const
}, {
  id: "infrastructure",
  title: "Infrastruktur",
  description: "Skalierbare Architekturberatung für moderne Enterprise-Umgebungen.",
  icon: TrainFront,
  badge: "",
  badgeVariant: "default" as const
}, {
  id: "cybersecurity",
  title: "Cybersecurity",
  description: "Ganzheitliche Abwehrstrategien gegen komplexe digitale Bedrohungen.",
  icon: CloudRain,
  badge: "Bedrohung: Niedrig",
  badgeVariant: "secondary" as const
}, {
  id: "compliance",
  title: "Compliance",
  description: "Sicherstellung gesetzlicher Standards und technologischer Exzellenz.",
  icon: Plane,
  badge: "",
  badgeVariant: "default" as const
}];
export default function SurvivalEssentials() {
  return <section data-section-id="224875" id="unsere-kernkompetenzen" className="bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-16 max-w-3xl">
          <h2 className="font-default text-5xl md:text-7xl font-bold uppercase tracking-tighter mb-6 text-foreground">
            Unsere <span className="text-primary">Kernkompetenzen</span>
          </h2>
          <p className="text-xl text-muted-foreground font-default max-w-xl">
            Technologische Exzellenz und strategische Beratung für Ihre digitale Souveränität.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {essentialsData.map((item, i) => {
          const Icon = item.icon;
          const isWeather = item.id === "cybersecurity";
          return <div data-index={i} key={item.id} className="h-full">
                <Card className="group relative h-full overflow-hidden bg-card/40 backdrop-blur-md border-border hover:border-primary transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/20 flex flex-col justify-between rounded-xl">
                  
                  {}
                  {isWeather && <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/cyber_mesh_pattern.png)] bg-cover bg-center opacity-10 mix-blend-screen pointer-events-none transition-opacity duration-1000 group-hover:opacity-20" />}

                  <CardHeader className="relative z-10 pb-2">
                    <div className="mb-8 flex items-start justify-between">
                      <Icon className="size-20 text-primary stroke-[1.5] transition-transform duration-500 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(0,255,255,0.5)]" />
                      {item.badge && <Badge variant={item.badgeVariant} className={`font-mono text-xs uppercase tracking-widest px-3 py-1 ${item.badgeVariant === "default" ? "bg-primary/10 text-primary border-primary/30 backdrop-blur-md" : "bg-secondary/10 text-secondary-foreground border-secondary/30 backdrop-blur-md"}`}>
                          {item.badge}
                        </Badge>}
                    </div>
                    <CardTitle className="font-default text-2xl font-bold uppercase tracking-tight mb-2">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10 pt-0">
                    <CardDescription className="text-muted-foreground text-base leading-relaxed font-default">
                      {item.description}
                    </CardDescription>
                  </CardContent>

                  {}
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}